import { multipleModelsGetter } from "@iventis/api-helpers-mapping";
import { DataField } from "@iventis/domain-model/model/dataField";
import { Model } from "@iventis/domain-model/model/model";
import { StyleType } from "@iventis/domain-model/model/styleType";
import { UnionOfStyles } from "@iventis/map-engine";
import { getAssetToCachedAsset } from "@iventis/utilities";
import { PagedResult } from "@iventis/domain-model/model/pagedResult";
import { Observable } from "rxjs";
import { IStyleService } from "@iventis/layer-styles";
import { assetCacheService, bustCacheIds, mappingApi, multipleAssetUrlGetter } from "@iventis/api/src/api";
import { imageCompressUrlGetter } from "./asset-compress-url-getter";
import { assetService } from "./asset-service";
import { rootStore } from "../state/root.store";

/** Api calls needed to edit styles in the main application */
export const editStyleService: IStyleService = {
    getLayerStyle: async (layerId: string, mapId: string, styleType: StyleType) => {
        const style = (await mappingApi.get<UnionOfStyles>(`/maps/${mapId}/layers/${layerId}/style`, { params: { styleType } })).data;
        if (typeof style === "string") {
            // Backend returns string if no style for some reason
            return null;
        }
        return style;
    },
    getDefaultModel: async () => {
        const response = await mappingApi.post<PagedResult<Model[]>>(`/models/filters?pageNumber=1`, []);
        return response.data.results[0];
    },
    getModelFromThumbnailId: async (thumbnailId: string) => {
        const response = await mappingApi.post<PagedResult<Model[]>>(`/models/filters?pageNumber=1`, [{ fieldName: "thumbnailAssetId", operator: "In", value: [thumbnailId] }]);
        return response.data.results[0];
    },
    assetGetter: multipleAssetUrlGetter,
    modelGetter: (ids) => multipleModelsGetter(ids, mappingApi),
    getProjectDataFields: async () => {
        const { projectId } = rootStore.getState().auth.user;
        const response = await mappingApi.get<DataField[]>(`/projects/${projectId}/data-fields`);
        return response.data.map((r) => ({ ...r, projectId }));
    },
    postProjectAttribute: async (attribute: DataField) => (await mappingApi.post<DataField>(`/projects/${rootStore.getState().auth.user.projectId}/data-fields`, attribute)).data,
    patchProjectAttribute: async (attribute: Partial<DataField>) =>
        (await mappingApi.patch<DataField>(`/projects/${rootStore.getState().auth.user.projectId}/data-fields/${attribute.id}`, attribute)).data,
    imageCompressor: imageCompressUrlGetter,
    isAssetSdf: async (id) => (await assetCacheService.get(id, async () => getAssetToCachedAsset(id, assetService.getAsset)))?.metaData?.sdf ?? false,
    bustCacheIds,
    refreshAssetEvent: new Observable(),
};
